export const Dashboard = {
    SidebarSelectCompany: 'Select company',
    RecentPipTests: 'Recent PIP Tests',
    LoadDisplacementPlot: 'Load Displacement Plot',
    ResidualIndentProfile: 'Residual Indent Profile',
    ProfilometerAlignmentCheck: 'Profilometer Alignment Check',
    AnisotropyCheck: 'Anisotropy Check',
    BrinellHardnessTest: 'Brinell Hardness Test',
    StressStrainCurves: 'Stress-Strain Curves',
    ResidualIndentProfiles: 'Residual Indent Profiles',
    MachineList: 'Machines',
    TotalTest: 'Total tests',
    TopMaterial: 'Top material',
    TotalSaved: 'Total Saved',
    MachineHealth: 'Machine Health',
    Machines: 'Machines',
};
